import { useCallback, useMemo } from 'react';

export function useMultiSelectValue(options, value, onChange) {
  // Build a react-select option object for every selected value. When the
  // matching option isn't in `options` yet — e.g. an async filter whose options
  // haven't loaded after the dropdown was reopened (MON-17753) — fall back to a
  // {value, label: value} stub so the selection still renders instead of going
  // blank. Once the real options load, the proper label takes over. Mirrors the
  // legacy MultiSelect and the FilterChip label fallback.
  const selectedOptions = useMemo(
    () =>
      value
        .filter((val) => val != null)
        .map(
          (val) =>
            options.find((opt) => opt.value === val) || {
              value: val,
              label: val,
            }
        ),
    [options, value]
  );

  const handleChange = useCallback(
    (selected) => {
      const newValues = selected ? selected.map((opt) => opt.value) : [];
      onChange(newValues);
    },
    [onChange]
  );

  return { selectedOptions, handleChange };
}

export function useSingleSelectValue(options, value, onChange) {
  const selectedOption = useMemo(
    () => options.find((opt) => opt.value === value) || null,
    [options, value]
  );

  const handleChange = useCallback(
    (selected) => {
      onChange(selected ? selected.value : '');
    },
    [onChange]
  );

  return { selectedOption, handleChange };
}

